import React from 'react';
import { CheckCircle } from 'lucide-react';

/**
 * Wizard step progress bar for the Configure Service flow.
 *
 * steps: array of { label: string }
 * currentStep: 1-based index of the active step
 */
const WizardProgress = ({ steps, currentStep }) => {
  return (
    <div className="mb-6">
      <div className="flex items-center">
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isActive = stepNumber === currentStep;
          const isLast = index === steps.length - 1;

          return (
            <React.Fragment key={stepNumber}>
              {/* Step circle */}
              <div className="flex flex-col items-center">
                <div
                  className={`flex items-center justify-center w-8 h-8 rounded-full border-2 text-sm font-semibold transition-colors ${
                    isCompleted
                      ? 'bg-green-500 border-green-500 text-white'
                      : isActive
                      ? 'bg-ga-primary border-ga-primary text-white'
                      : 'bg-white border-gray-300 text-gray-400'
                  }`}
                >
                  {isCompleted ? (
                    <CheckCircle className="h-4 w-4" />
                  ) : (
                    stepNumber
                  )}
                </div>
                <span
                  className={`mt-1 text-xs font-medium text-center max-w-[80px] leading-tight ${
                    isActive ? 'text-ga-primary' : isCompleted ? 'text-green-600' : 'text-gray-400'
                  }`}
                >
                  {step.label}
                </span>
              </div>

              {/* Connector line */}
              {!isLast && (
                <div
                  className={`flex-1 h-0.5 mx-2 mb-5 transition-colors ${
                    isCompleted ? 'bg-green-500' : 'bg-gray-200'
                  }`}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
      <p className="text-xs text-gray-500 mt-2">
        Step {currentStep} of {steps.length}
      </p>
    </div>
  );
};

export const SERVICE_WIZARD_STEPS = [
  { label: 'Facility Services' },
  { label: 'Configure Service' },
  { label: 'Date Range' },
  { label: 'Price Setup' },
  { label: 'Calendar View' },
];

export default WizardProgress;
